import React from 'react';
import TruncatedText from '@spark/ui-components/components/TanStackTable/components/TruncatedText';
import Tooltip from '@spark/ui-components/components/Tooltip';
import CheckBox from '@spark/ui-components/components/form/CheckBox';
import { Button } from '@spark/ui-components/components/Button';
import Icon from '@spark/ui-components/components/Icon';

export const getAssociacaoTabelaColumns = ({
  selectedIds,
  onToggleSelect,
  onToggleSelectAll,
  allPageSelected,
  selectAllDisabled,
  onGerenciar
}) => {
  const selectionHeader = (
    <div style={{ display: 'inline-flex', alignItems: 'center', gap: 8 }}>
      <Tooltip dir="top" text={allPageSelected ? 'Remover seleção da página' : 'Selecionar página'}>
        <span className="d-inline-flex align-items-center">
          <CheckBox
            name="select-all-associacao-tabelas"
            checked={!!allPageSelected}
            disabled={!!selectAllDisabled}
            label=""
            onChange={(event) => {
              event.stopPropagation();
              onToggleSelectAll();
            }}
            onClick={(event) => event.stopPropagation()}
          />
        </span>
      </Tooltip>
      <span>Sel.</span>
    </div>
  );

  return [
    {
      id: 'select',
      header: () => selectionHeader,
      size: 70,
      enableSorting: false,
      enableCopy: false,
      cell: ({ row }) => {
        const rowId = String(row.original.id);
        const isSelected = selectedIds?.includes(rowId);
        return (
          <CheckBox
            name={`select-associacao-tabela-${rowId}`}
            checked={!!isSelected}
            label=""
            onChange={(event) => {
              event.stopPropagation();
              onToggleSelect(rowId);
            }}
            onClick={(event) => event.stopPropagation()}
          />
        );
      }
    },
    {
      id: 'id',
      header: 'Id',
      accessorKey: 'id',
      size: 80,
      cell: ({ getValue }) => <TruncatedText value={getValue() ?? '-'} maxLength={8} />
    },
    {
      id: 'nome',
      header: 'Nome',
      accessorKey: 'nome',
      cell: ({ getValue }) => <TruncatedText value={getValue() || '-'} maxLength={24} />
    },
    {
      id: 'segmento',
      header: 'Segmento',
      accessorKey: 'segmento',
      cell: ({ getValue }) => <TruncatedText value={getValue() || '-'} maxLength={18} />
    },
    {
      id: 'acoes',
      header: 'Ações',
      size: 100,
      enableSorting: false,
      enableCopy: false,
      cell: ({ row }) => (
        <Tooltip dir="top" text="Gerenciar tabela">
          <Button
            variant="outline-primary"
            size="sm"
            onClick={(event) => {
              event.stopPropagation();
              onGerenciar(row.original);
            }}
          >
            <Icon name="settings" size={16} />
          </Button>
        </Tooltip>
      )
    }
  ];
};
